export const EventUseCase = {
  DEFAULT: null,
  IMPROVE_PERFORMANCE: 'IMPROVE_PERFORMANCE',
  SURVEY: 'SURVEY',
  BEFORE_A_MEETING: 'BEFORE_A_MEETING',
  AFTER_A_MEETING: 'AFTER_A_MEETING',
  BEFORE_A_TOWNHALL: 'BEFORE_A_TOWNHALL',
  AFTER_A_TOWNHALL: 'AFTER_A_TOWNHALL',
  TEST_ADOPTION: 'TEST_ADOPTION',
  SOURCE_IDEAS: 'SOURCE_IDEAS',

  isBeforeQuestion (useCase) {
    return (useCase || '').toUpperCase().startsWith('BEFORE_A_');
  },

  isAfterQuestion (useCase) {
    return (useCase || '').toUpperCase().startsWith('AFTER_A_');
  }
};

export const eventUseCaseFromString = (useCase) => {
  if (useCase === null) {
    // Default use case is null
    return EventUseCase.DEFAULT;
  }

  return (useCase || '').toUpperCase();
};

